<template>
	<div class="box scroll-y" style="height: 271px">
		<div class="padding py-4 h-100">
			<span class="actions text-muted">
				<a @click="loadData" class="no-select btn-subtle" v-tippy title="Refresh">
					<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
				</a>
			</span>

			<div v-if="assessments" class="h-100 d-flex flex-column">
				<h4 class="mb-0 pb-2 text-theme">
					<i class="fas fa-book fa-fw"></i>
					<span>Assessments</span>
				</h4>
				<div class="flex d-flex flex-row align-items-center">
					<div class="flex h-100 scroll-y">
						<table>
							<tr v-for="stat in assessments" :key="stat.assessment_id">
								<td
									class="nowrap pr-2 b-r py-1 b-b"
									v-tippy
									:title="
										`Used in ${stat.assigned_count} ${
											stat.assigned_count == 1 ? 'class' : 'classes'
										}`
									"
								>
									<i class="fas fa-chalkboard fa-fw"></i>
									<span>{{ stat.assigned_count }}</span>
								</td>
								<td class="pl-2 py-1 b-b">
									<span class="text-muted text-sm">{{ stat.assessment.ref_id }}</span>
									•
									{{ stat.assessment.name }}
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.actions {
	position: absolute;
	right: 1.5rem;
	top: 0.5rem;
}
a.btn-subtle {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a.btn-subtle:hover {
	opacity: 1;
}
ul {
	padding-left: 1.5rem;
	padding-right: 0.5rem;
}
::-webkit-scrollbar {
	width: 7px;
}
::-webkit-scrollbar-thumb {
	border-radius: 4px;
	background-color: rgba(0, 0, 0, 0.2);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>

<script>
import ReportingService from "@/services/ReportingService";

export default {
	name: "TrafficDashAssessments",

	data() {
		return {
			assessments: null,

			busy: false
		};
	},

	props: ["user"],

	created() {
		this.loadData();
	},
	watch: {},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			ReportingService.getAssessmentsByAssignments()
				.then(resp => {
					console.log("assessments", resp.data);
					this.assessments = resp.data;
				})
				.catch(err => {
					console.error("Failed to load dashboard data for assessments");
					console.error(err);
				})
				.finally(() => {
					this.busy = false;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/TrafficDashboard/TrafficDashAssessments.vue